import Model from '../utils/Model'
import CommonState from '@/class/cargo/model/parameters/CommonState'
class ContainerLoadType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'ContainerLoadType'

export const FCL_CARGO_TYPE = new ContainerLoadType('FCL', '整箱', 'FCL')
export const LCL_CARGO_TYPE = new ContainerLoadType('LCL', '自拼箱', 'LCL')
export const BB_CARGO_TYPE = new ContainerLoadType('BB', '委托拼箱', 'Consignment LCL')// Co Loader
export const BC_CARGO_TYPE = new ContainerLoadType('BC', 'Buyer Console', 'Buyer Console')
export const BULK_CARGO_TYPE = new ContainerLoadType('BULK', '散杂货', 'BULK')
export const SPECIAL_CARGO_TYPE = new ContainerLoadType('SPA', '特种箱', 'Special')
export const BC_CARGO_TYPE_FCL = new ContainerLoadType('BCF', 'Buyer Console FCL', 'Buyer Console FCL')

export const STUFFY_TT = new CommonState('TT', '集卡拖车', 'Truck Trailer')
export const STUFFY_CL = new CommonState('CL', '整车/零担', 'WholeVehicle Less Than Carload')
export const STUFFY_IC = new CommonState('IC', '国际卡航', 'International Card Airlines')

export const CONTAINERLOAD_TYPES = [FCL_CARGO_TYPE, LCL_CARGO_TYPE, BB_CARGO_TYPE, BC_CARGO_TYPE, BULK_CARGO_TYPE, SPECIAL_CARGO_TYPE, BC_CARGO_TYPE_FCL]

export const FBA_CONTAINERLOAD_TYPES = [FCL_CARGO_TYPE, LCL_CARGO_TYPE, BB_CARGO_TYPE, BC_CARGO_TYPE, BULK_CARGO_TYPE, SPECIAL_CARGO_TYPE, BC_CARGO_TYPE_FCL]

export const CONTAINERLOAD_TYPES_ALL_LCL = [LCL_CARGO_TYPE, BC_CARGO_TYPE, BB_CARGO_TYPE]

export const CONTAINERLOAD_TYPES_LCL = [LCL_CARGO_TYPE, BC_CARGO_TYPE, BC_CARGO_TYPE_FCL]

export const CARGO_TYPES_BASIC_DATA = [FCL_CARGO_TYPE, LCL_CARGO_TYPE, BB_CARGO_TYPE, BC_CARGO_TYPE, BULK_CARGO_TYPE]

// 综合物流
export const IE_TYPES = [STUFFY_TT, STUFFY_CL, STUFFY_IC]

export const DIRECT = new CommonState('DIRECT', '直单', 'Direct')
export const CONSOLE = new CommonState('CONSOLE', '一主多分', 'Console')

/**
 * 综合物流主票操作模式
 */
export const MASTER_OPERATE_TYPES = [CONSOLE]

/**
 * 综合物流操作模式
 */
export const OPERATE_TYPES = [DIRECT, CONSOLE]

/**
		 *  return null:没找到.
		 */
export function getContainerLoadTypeByCode(code) {
  return Model.getObjByCode(code, CONTAINERLOAD_TYPES)
}

/**
		 *  return null:没找到.
		 */
export function getContainerLoadTypeByBusType(code, arrs) {
  return Model.getObjByCode(code, arrs)
}

/**
 *  return null:没找到.
 */
export function getContainerLoadTypeByName(name) {
  let foundObj = null
  for (const obj of CONTAINERLOAD_TYPES) {
    if (name && obj.englishName === name) {
      foundObj = obj
      break
    }
    if (name && obj.chineseName === name) {
      foundObj = obj
      break
    }
  }
  return foundObj
}

/**
 *  return null:没找到.
 */
export function queryContainerLoadTypeByName(name, list) {
  let foundObj = null
  if (!list || !name) {
    return null
  }
  for (const obj of list) {
    if (name && obj.englishName === name) {
      foundObj = obj
      break
    }
    if (name && obj.chineseName === name) {
      foundObj = obj
      break
    }
  }
  return foundObj
}

